module.exports = __webpack_public_path__ + "img/70.d82603f.png";